/* SupaSeed theme scripts */
(function () {
  // Fade-in on scroll
  function initReveal(root) {
    const items = (root || document).querySelectorAll('.ss-reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    items.forEach((el) => io.observe(el));
  }

  // Keep every cart counter on the page in sync
  function setCartCount(count) {
    document.querySelectorAll('[data-ss-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  // Add to cart from product cards without leaving the page
  const t = window.ssStrings || {};
  let toastTimer;

  function showToast(html, isError) {
    let toast = document.querySelector('.ss-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ss-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.classList.toggle('ss-toast--error', !!isError);
    toast.innerHTML = html;
    toast.querySelector('[data-ss-toast-close]')?.addEventListener('click', () => toast.classList.remove('is-open'));
    requestAnimationFrame(() => toast.classList.add('is-open'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-open'), 5000);
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function bumpCart() {
    document.querySelectorAll('.ss-header__cart').forEach((el) => {
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-ss-add-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const label = button.innerHTML;
    button.disabled = true;
    button.classList.add('is-loading');
    button.innerHTML = t.adding || '…';
    try {
      const res = await fetch(window.Shopify?.routes?.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) throw new Error('add failed');
      const cart = await fetch('/cart.js').then((r) => r.json());
      setCartCount(cart.item_count);
      bumpCart();
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.innerHTML = button.dataset.addedLabel || '✓';
      showToast(
        '<span class="ss-toast__icon" aria-hidden="true">✓</span>' +
          '<p class="ss-toast__text"><strong>' + escapeHtml(form.dataset.productTitle) + '</strong> ' + escapeHtml(t.toast) + '</p>' +
          '<a class="ss-btn ss-toast__btn" href="' + (t.cartUrl || '/cart') + '">' + escapeHtml(t.viewCart) + '</a>' +
          '<button type="button" class="ss-toast__close" data-ss-toast-close aria-label="' + escapeHtml(t.close) + '">×</button>'
      );
    } catch (e) {
      button.classList.remove('is-loading');
      button.innerHTML = button.dataset.errorLabel || '!';
      showToast('<p class="ss-toast__text">' + escapeHtml(t.error) + '</p><button type="button" class="ss-toast__close" data-ss-toast-close aria-label="' + escapeHtml(t.close) + '">×</button>', true);
    }
    setTimeout(() => {
      button.innerHTML = label;
      button.disabled = false;
      button.classList.remove('is-added');
    }, 2500);
  });

  // Language selector: switch as soon as a language is picked
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-ss-autosubmit]');
    if (select) select.form.submit();
  });

  // Hero slider
  class SsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = 0;
      if (this.slides.length < 2) return;

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));

      // Swipe on touch devices
      let startX = null;
      this.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
      this.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), true);
        startX = null;
      });

      this.delay = parseInt(this.dataset.autoplay || '0', 10) * 1000;
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.start();
    }
    disconnectedCallback() {
      this.stop();
    }
    start() {
      this.stop();
      if (this.delay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => this.go(this.index + 1), this.delay);
      }
    }
    stop() {
      clearInterval(this.timer);
    }
    go(i, manual) {
      const n = this.slides.length;
      this.index = (i + n) % n;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.slides.forEach((s, k) => {
        s.setAttribute('aria-hidden', k !== this.index);
        s.querySelectorAll('a,button').forEach((el) => (el.tabIndex = k === this.index ? 0 : -1));
      });
      this.dots.forEach((d, k) => d.setAttribute('aria-current', k === this.index));
      if (manual) this.start();
    }
  }
  if (!customElements.get('ss-slider')) customElements.define('ss-slider', SsSlider);

  // Header account dropdown: hover on desktop, tap on touch screens.
  // Shopify's sign-in panel lives inside it, so it stays open while that panel is in use.
  function initAccountMenu() {
    const root = document.querySelector('[data-ss-acct]');
    if (!root) return;
    const toggle = root.querySelector('[data-ss-acct-toggle]');
    const signin = root.querySelector('[data-ss-acct-signin]');
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    let closeTimer;
    let locked = false;

    function open() {
      clearTimeout(closeTimer);
      const header = root.closest('.ss-header') || document.querySelector('.ss-header');
      if (header) root.style.setProperty('--ss-acct-top', Math.max(header.getBoundingClientRect().bottom, 0) + 8 + 'px');
      root.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      clearTimeout(closeTimer);
      locked = false;
      root.classList.remove('is-open', 'is-handoff');
      toggle.setAttribute('aria-expanded', 'false');
    }

    // With a mouse, hovering already opened it, so a click must not close it again
    toggle.addEventListener('click', () =>
      root.classList.contains('is-open') && !canHover.matches ? close() : open()
    );
    root.addEventListener('mouseenter', () => canHover.matches && open());
    root.addEventListener('mouseleave', () => {
      if (canHover.matches && !locked) closeTimer = setTimeout(close, 250);
    });
    // Fade our menu out while Shopify's sign-in dialog is open, reset when it closes
    if (signin) {
      signin.addEventListener('click', () => {
        locked = true;
        root.classList.add('is-handoff');
        setTimeout(() => {
          const host = signin.closest('shopify-account');
          const dialog = host && host.shadowRoot && host.shadowRoot.querySelector('dialog');
          if (dialog && dialog.open) dialog.addEventListener('close', close, { once: true });
          else close();
        }, 400);
      });
    }
    root.querySelectorAll('[data-ss-acct-open]').forEach((btn) =>
      btn.addEventListener('click', () => signin && signin.click())
    );
    document.addEventListener('click', (e) => {
      if (root.classList.contains('is-open') && !e.composedPath().includes(root)) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && root.classList.contains('is-open') && !locked) {
        close();
        toggle.focus();
      }
    });
  }
  document.addEventListener('DOMContentLoaded', initAccountMenu);

  // Product page: keep "In den Warenkorb" reachable. While the real button is
  // below the screen the bar sits at the bottom; once scrolled past, at the top.
  function initStickyBuy() {
    const page = document.querySelector('.ss-pp');
    if (!page || !page.querySelector('.product-form__submit') || document.querySelector('.ss-sticky-buy')) return;

    const bar = document.createElement('div');
    bar.className = 'ss-sticky-buy';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<button type="button" class="ss-sticky-buy__btn" tabindex="-1"><span></span></button>';
    document.body.appendChild(bar);
    const btn = bar.querySelector('button');
    const label = btn.querySelector('span');
    const realBtn = () => page.querySelector('.product-form__submit');

    // Mirror label, sold-out and loading state of the real button
    function sync() {
      const real = realBtn();
      if (!real) return;
      const text = real.querySelector('span:not(.loading__spinner)');
      label.textContent = (text ? text.textContent : real.textContent).trim();
      const off = real.disabled || real.getAttribute('aria-disabled') === 'true';
      btn.disabled = off;
      btn.classList.toggle('is-loading', real.classList.contains('loading'));
    }

    let ticking = false;
    function place() {
      ticking = false;
      const real = realBtn();
      if (!real) return;
      const r = real.getBoundingClientRect();
      const below = r.top > window.innerHeight;
      const above = r.bottom < 0;
      const show = below || above;
      bar.classList.toggle('is-visible', show);
      if (show) {
        bar.classList.toggle('is-top', above);
        bar.classList.toggle('is-bottom', below);
      }
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }
    function queue() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(place);
      }
    }

    btn.addEventListener('click', () => {
      const real = realBtn();
      if (real && !real.disabled) real.click();
    });
    new MutationObserver(sync).observe(page, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
    });
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    sync();
    place();
  }
  document.addEventListener('DOMContentLoaded', initStickyBuy);

  document.addEventListener('DOMContentLoaded', () => initReveal());
  // Re-run when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', (e) => initReveal(e.target));
})();
